// extracted by mini-css-extract-plugin
module.exports = {"kitC":"kitC_kitC__4dI9s"};